module.exports = __webpack_public_path__ + "static/img/student_member_price.7ef05c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/student_member_price.png
// module id = TOZU
// module chunks = 2